import { render, staticRenderFns } from "./RecipientsTree.vue?vue&type=template&id=45ea6184&scoped=true&"
import script from "./RecipientsTree.vue?vue&type=script&lang=js&"
export * from "./RecipientsTree.vue?vue&type=script&lang=js&"
import style0 from "./RecipientsTree.vue?vue&type=style&index=0&id=45ea6184&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ea6184",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ea6184')) {
      api.createRecord('45ea6184', component.options)
    } else {
      api.reload('45ea6184', component.options)
    }
    module.hot.accept("./RecipientsTree.vue?vue&type=template&id=45ea6184&scoped=true&", function () {
      api.rerender('45ea6184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/eCircular/RecipientsTree.vue"
export default component.exports